/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {updateEmployeeRole} from '../api'

export const useMutationUpdateEmployeeRole = createReactQueryMutationHook('updateEmployeeRole', updateEmployeeRole)
